"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxInputPassword = void 0;

var _reactEmotion = require("react-emotion");

var boxInputPassword =
/*#__PURE__*/
(0, _reactEmotion.css)("position:relative;.toggle-password{position:absolute;top:50%;right:13px;transform:translateY(-50%);}");
exports.boxInputPassword = boxInputPassword;